var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M19.658 13.503C22.713 7.012 29.37 2.508 37.084 2.508c10.602 0 19.209 8.51 19.209 18.99 0 3.124-1.706 8.191-4.1 13.764H21.975c-1.385-3.224-2.54-6.28-3.268-8.887m18.377-12.833c3.874 0 7.02 3.11 7.02 6.94 0 3.83-3.146 6.94-7.02 6.94-3.874 0-7.02-3.11-7.02-6.94 0-3.83 3.146-6.94 7.02-6.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    fillRule: "nonzero",
    d: "M25.076 72.507H2.5V68.27L15.047 52.65H2.797v-5.543h21.962v4.222L12.212 66.965h12.864v5.542z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    fillRule: "nonzero",
    d: "M35.37 -29.22H43.171V-0.49199999999999733H35.37z",
    transform: "matrix(1.00873 0 0 .88415 -2.401 72.507)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    fillRule: "nonzero",
    d: "M61.499 47.107c3.674 0 6.426.702 8.255 2.103 1.831 1.401 2.746 3.393 2.746 5.976 0 1.158-.188 2.27-.565 3.336-.376 1.065-.991 2.015-1.844 2.85-.851.833-1.98 1.494-3.389 1.98-1.407.486-3.141.73-5.203.73h-2.2v8.425H51.47v-25.4H61.5zm-.178 5.543H59.3v5.837h1.546c.674 0 1.302-.101 1.884-.304a2.927 2.927 0 001.397-.99c.35-.457.525-1.068.525-1.833 0-.8-.271-1.45-.813-1.955-.542-.503-1.38-.755-2.517-.755z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipcode);
export default __webpack_public_path__ + "static/media/zipcode.48abf33ab2a18db3af5877500675fdf6.svg";
export { ForwardRef as ReactComponent };